export default __webpack_public_path__ + "static/media/desktop_tc3_Hk.4a35c9e4.webp";